import React from 'react';
import { motion } from 'framer-motion';
import { Euro } from 'lucide-react';
import { useProducts } from '../../../context/ProductContext';

export const PriceRangeFilter: React.FC = () => {
  const { priceRange, setPriceRange } = useProducts();
  const MAX_PRICE = 1000;

  const handleMinPriceChange = (value: number) => {
    setPriceRange([value, Math.max(value, priceRange[1])]);
  };

  const handleMaxPriceChange = (value: number) => {
    setPriceRange([Math.min(value, priceRange[0]), value]);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
          <Euro className="text-orange-500" size={16} />
          Precio mínimo: {priceRange[0].toFixed(2)}€
        </label>
        <div className="relative mt-2">
          <motion.input
            whileFocus={{ scale: 1.02 }}
            type="range"
            min={0}
            max={MAX_PRICE}
            step={1}
            value={priceRange[0]}
            onChange={(e) => handleMinPriceChange(Number(e.target.value))}
            className="w-full h-2 bg-orange-200 rounded-lg appearance-none cursor-pointer accent-orange-500"
          />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>0€</span>
            <span>{MAX_PRICE}€</span>
          </div>
        </div>
      </div>

      <div>
        <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
          <Euro className="text-orange-500" size={16} />
          Precio máximo: {priceRange[1].toFixed(2)}€
        </label>
        <div className="relative mt-2">
          <motion.input
            whileFocus={{ scale: 1.02 }}
            type="range"
            min={0}
            max={MAX_PRICE}
            step={1}
            value={priceRange[1]}
            onChange={(e) => handleMaxPriceChange(Number(e.target.value))}
            className="w-full h-2 bg-orange-200 rounded-lg appearance-none cursor-pointer accent-orange-500"
          />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>0€</span>
            <span>{MAX_PRICE}€</span>
          </div>
        </div>
      </div>
    </div>
  );
};